import { useEffect, useState } from "react";
import RiskInnerNew from "./RiskInnerNew";
import RiskModal from "./RiskModal";
import { Link } from "react-router-dom";
import BookPosition from "./BookPosition";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../Utils/Constant";

const Risk = () => {
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [headerTab, setHeaderTab] = useState("matched");
  const [topData, setTopdata] = useState({});
  const sports = [
    { id: "cricket", label: "Cricket" },
    { id: "tennis", label: "Tennis" },
    { id: "soccer", label: "Soccer" },
    { id: "all", label: "All" },
  ];

  const [sport, setSport] = useState("all");

  const getTopAmount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.riskProfile);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setTopdata(response_users.results);
        }
      }
    }
  };

  useEffect(() => {
    getTopAmount();
  }, []);

  const topList =
    headerTab === "matched"
      ? topData?.matched
      : headerTab === "exposure"
        ? topData?.exposure
        : topData?.winners;

  return (
    <app-risk-management-sky
      _nghost-serverapp-c186
      className="ng-star-inserted"
    >
      <div _ngcontent-serverapp-c186 className="main_wrap">
        <div
          style={{
            margin: "13px 0 5px",
            display: "flow-root",
          }}
          _ngcontent-serverapp-c186
          className="total_all"
        >
          <h2
            style={{
              color: "#243a48",
              fontSize: "16px",
              fontWeight: "700",
            }}
            _ngcontent-serverapp-c186
          >
            Risk Management Summary
          </h2>
          <a
            _ngcontent-serverapp-c186
            id="refresh_Top_Racing"
            className="btn_replay"
            style={{ display: "none" }}
          >
            <img
              _ngcontent-serverapp-c186
              src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
            />
          </a>
        </div>
        <div
          style={{ marginBottom: "20px" }}
          _ngcontent-serverapp-c186
          className="play_race-wrap"
        >
          <div _ngcontent-serverapp-c186 className="function-wrap">
            <ul className="input-list">
              {sports.map((item) => (
                <li key={item.id}>
                  <a
                    id={item.id}
                    className={`btn-send ${sport === item.id ? "selected" : ""}`}
                    onClick={() => setSport(item.id)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="top_player-wrap">
            <h3>
              <ul className="tab-topplay">
                {" "}
              
                <li
                  id="top10MatchedAmountLi"
                  className={headerTab === "matched" ? "select" : ""}
                  onClick={() => setHeaderTab("matched")}
                >
                  <a>Top 20 Matched Amount Player</a>
                </li>
                  <li
                  id="top10ExposureLi"
                  className={headerTab === "exposure" ? "select" : ""}
                  onClick={() => setHeaderTab("exposure")}
                >
                  <a>Top 20 Exposure Player</a>
                </li>
                <li
                  id="top10WinnersLi"
                  className={headerTab === "winners" ? "select" : ""}
                  onClick={() => setHeaderTab("winners")}
                >
                  <a>Top 20 Winners Player</a>
                </li>
              </ul>
            </h3>
            <div
              style={{ width: "50%", display: "block", padding: "0" }}
              className="col-2"
            >
              <ul className="slip-head">
                <li className="col-playID">UID</li>{" "}
                <li
                  style={{ float: "right", display: "block" }}
                  className="col-amount sort-this align-R"
                >
                  {headerTab === "winners" ? "Total Stake" : "Matched Amount"}
                </li>
                <li
                  style={{ float: "right", display: "block" }}
                  className="col-exp align-R"
                >
                  {headerTab === "winners" ? "Total Profit" : "Exposure"}
                </li>
              </ul>
              <table className="table01 table-responsive">
                <tbody id="content_top_1_5">
                  {topList?.length > 0 &&
                    topList.slice(0, 10).map((res, index) => (
                      <tr key={res?._id || index}>
                        <td className="align-L">
                          <span id="number" className="order">
                            {index + 1}.
                          </span>
                          <Link
                            style={{ textDecoration: "underline" }}
                            id="userId"
                            to={`/my-account/current-bets/${res?._id || res?.userId}/user`}
                          >
                            {res?.username || res?.clientName}
                          </Link>
                        </td>
                        <td
                          id="exposure"
                          width={80}
                          style={{ textAlign: "left" }}
                        >
                          <span
                            className={
                              headerTab === "winners" ? "green" : "red"
                            }
                          >
                            (
                            {toFixedWithoutRounding(
                              res?.exposure || res?.profitAmount,
                            )}
                            )
                          </span>
                        </td>
                        <td id="amount" width={110}>
                          {toFixedWithoutRounding(res?.totalAmount || res?.amount)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div
              style={{ width: "50%", display: "block", padding: "0" }}
              className="col-2"
            >
              <ul className="slip-head">
                <li className="col-playID">UID</li>

                <li
                  style={{ float: "right", display: "block" }}
                  className="col-amount sort-this align-R"
                >
                  {headerTab === "winners" ? "Total Stake" : "Matched Amount"}
                </li>
                <li
                  style={{ float: "right", display: "block" }}
                  className="col-exp align-R"
                >
                  {headerTab === "winners" ? "Total Profit" : "Exposure"}
                </li>
              </ul>
              <table className="table01 table-responsive">
                <tbody id="content_top_6_10">
                  {topList?.length > 0 &&
                    topList.slice(10, 20).map((res, index) => (
                      <tr key={res?._id || index}>
                        <td className="align-L">
                          <span id="number" className="order">
                            {index + 11}.
                          </span>
                          <Link
                            style={{ textDecoration: "underline" }}
                            id="userId"
                            to={`/my-account/current-bets/${res?._id || res?.userId}/user`}
                          >
                            {res?.username || res?.clientName}
                          </Link>
                        </td>
                        <td
                          id="exposure"
                          width={80}
                          style={{ textAlign: "left" }}
                        >
                          <span
                            className={
                              headerTab === "winners" ? "green" : "red"
                            }
                          >
                            (
                            {toFixedWithoutRounding(
                              res?.exposure || res?.profitAmount,
                            )}
                            )
                          </span>
                        </td>
                        <td id="amount" width={110}>
                          {toFixedWithoutRounding(res?.totalAmount || res?.amount)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <RiskInnerNew
          show={show}
          setShow={setShow}
          setModal={setModal}
          sport={sport}
        />
      </div>
      <RiskModal
        isOpen={show?.status}
        onClose={setShow}
        eventId={show?.eventId}
        marketId={show?.marketId}
        type={show?.type}
        userId={show?.id}
        userType={show?.userType}
        selectionId={show?.selectionId || ""}
      />
      <BookPosition isOpen={modal?.status} object={modal} onClose={setModal} />
    </app-risk-management-sky>
  );
};

export default Risk;
